<script setup>
import { computed, onMounted, nextTick } from "vue";
import { useGlobalStore } from "@stores/global.js";
import { useShopifyStore } from "@stores/shopify.js";

const global = useGlobalStore();
const shopify = useShopifyStore();

const collections = computed(() => shopify.teamsCollections);

onMounted(() => {
	nextTick(() => {
		global.setHeaderTheme(null, null, null);
		global.setTheme(null, null, null);
	});
});
</script>

<template>
	<section class="py-8" v-if="collections.length > 0">
		<div class="grid gap-8 lg:grid-cols-3">
			<div
				class="group text-text-inverted hover:border-theme @container relative isolate flex aspect-square items-end overflow-hidden rounded-lg border-2 border-transparent p-16 transition-colors before:absolute before:inset-0 before:-z-1 before:size-full before:bg-linear-to-t before:from-black/50 before:to-transparent md:p-24 lg:p-48"
				v-for="collection in collections"
				:key="collection.id"
				:collection="collection"
				@mouseenter="
					if (global.pointerFine) {
						global.setHeaderTheme(
							collection.theme?.background,
							collection.theme?.accent,
							collection.theme?.surface,
						);
						$event.currentTarget.style.setProperty(
							'--theme-accent',
							collection.theme?.accent,
						);
					}
				"
				@mouseleave="
					global.setHeaderTheme(null, null, null);
					$event.currentTarget.style.removeProperty('--theme-accent');
				"
			>
				<img
					:src="collection.image"
					:alt="collection.image_alt || collection.title"
					class="absolute inset-0 -z-2 size-full object-cover transition-transform duration-500 group-hover:scale-105"
				/>
				<div class="flex w-full items-center justify-center">
					<router-link
						:to="{
							name: 'collection',
							params: { slug: collection.slug },
						}"
						class="box-link"
						:aria-label="collection.title"
					>
						<img
							:src="collection?.logo"
							:alt="collection?.logo_alt || collection?.title"
							class="size-full h-56 max-w-300 object-contain object-center"
						/>
					</router-link>
				</div>
			</div>
		</div>
	</section>
</template>
